module.exports = __webpack_public_path__ + "media/bootstrap-icons/camera-reels-fill-afc6d207.svg";